export default "__VITE_ASSET__DLR49$Iy__"